<template>
  <blockquote v-if="text || 'default' in $slots" class="c-blockquote">
    {{ text }}
    <slot/>
  </blockquote>
</template>

<script>
import { props } from './props'

export default {
  name: 'CBlockquote',
  props
}
</script>

<style lang="scss">
@import "style";
</style>
